import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import setSearchedLocation from '@location/actions/setSearchedLocation';
import validateNewAddress from '@core/reducers/addresses/actions/validateNewAddress';
import updateSearchForm from '@location/actions/updateSearchForm';
import { getIsUserLogged } from '@shared/selectors';
import getCurrentUser from '@core/reducers/user/selectors/getCurrentUser';
import getSearchedLocation from '@location/selectors/getSearchedLocation';
import trackMapLoaded from '@location/tracking/actions/trackMapLoaded';
import LocationParcel from './LocationParcel';

const mapStateToProps = createStructuredSelector({
  searchedLocation: getSearchedLocation,
  isUserLogged: getIsUserLogged,
  currentUser: getCurrentUser,
});

const mapDispatchToProps = {
  setSearchedLocation,
  validateNewAddress,
  setAddressInSearchForm: updateSearchForm,
  trackMapLoaded,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationParcel);
